import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ChartComponentData} from "../../interfaces/chart-component-data";
import {PieChartData} from "../../interfaces/pie-chart-data";
import {LineChartData} from "../../interfaces/line-chart-data";
@Component({
  selector: 'brt-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit, AfterViewInit {

  @ViewChild("mainEl") mainEl!: ElementRef;
  @ViewChild("lineChart") lineChart!: ElementRef;
  @ViewChild("miniChart") miniChart!: ElementRef;

  @Output('onIndexHover') onIndexHover: EventEmitter<number> = new EventEmitter();
  @Output('onIndexHoverOut') onIndexHoverOut: EventEmitter<void> = new EventEmitter();

  @Input('data') set setData(val: ChartComponentData) {
    if(val.type === "pie") {
      this.pieChartData = val.data as PieChartData;
    } else if(val.type === "line") {
      this.lineChartData = val.data as LineChartData;
    } else if(val.type === "line-preview") {
      this.miniChartData = val.data as LineChartData;
    }
  }

  pieChartData?: PieChartData;
  lineChartData?: LineChartData;
  miniChartData?: LineChartData;

  // currentSelection = -1;
  // data = [
  //   { year: 2010, count: 10 },
  //   { year: 2011, count: 20 },
  //   { year: 2012, count: 15 },
  //   { year: 2013, count: 25 },
  //   { year: 2014, count: 22 },
  //   { year: 2015, count: 30 },
  //   { year: 2016, count: 28 },
  // ];
  ngOnInit(): void {
  }

  ngAfterViewInit(): void {

    // const lineChart = new Chart(
    //   this.lineChart.nativeElement as HTMLCanvasElement,
    //   {
    //     type: 'line',
    //     options: {
    //       scales: {
    //         y: {
    //           suggestedMax: 234
    //         }
    //       },
    //       onHover: (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
    //         this.currentSelection = elements[0].index;
    //
    //       },
    //       events: ["mouseenter", "mouseout", "mousemove"],
    //       plugins: {
    //         legend: {
    //           display: false
    //         }
    //       },
    //       hover: {
    //         mode: 'nearest',
    //         intersect: false,
    //       }
    //     },
    //     data: {
    //       labels: this.data.map(row => row.year),
    //       datasets: [
    //         {
    //           label: 'Acquisitions by year',
    //           data: this.data.map(row => row.count),
    //           tension: 1
    //         },
    //         {
    //           label: 'Acquisitions by year 2',
    //           data: this.data.map(row => row.count + Math.floor(Math.random() * 300)),
    //           tension: 2
    //         },
    //         {
    //           label: 'Acquisitions by year 2',
    //           data: this.data.map(row => row.count + Math.floor(Math.random() * 100)),
    //           tension: 0.4
    //         }
    //       ]
    //     }
    //   }
    // );



    // const miniChart = new Chart(
    //   this.miniChart.nativeElement as HTMLCanvasElement,
    //   {
    //     type: 'line',
    //     options: {
    //       scales: {
    //         x: {
    //           display: false
    //         },
    //         y: {
    //           display: false
    //         }
    //       },
    //       onHover: (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
    //         this.currentSelection = elements[0].index;
    //
    //       },
    //       events: [],
    //       plugins: {
    //         legend: {
    //           display: false
    //         },
    //         tooltip: {
    //           enabled: false
    //         }
    //       },
    //       hover: {
    //         mode: 'nearest',
    //         intersect: false,
    //       }
    //     },
    //     data: {
    //       labels: this.data.map(row => row.year),
    //       datasets: [
    //         {
    //           label: 'Acquisitions by year 2',
    //           data: this.data.map(row => row.count + Math.floor(Math.random() * 100)),
    //           tension: 0.4,
    //           pointRadius: 0,
    //           borderColor: (context) => {
    //             const chart = context.chart;
    //             const {ctx, chartArea} = chart;
    //
    //             if (!chartArea) {
    //               // This case happens on initial chart load
    //               return;
    //             }
    //             const chartWidth = chartArea.right - chartArea.left;
    //             const chartHeight = chartArea.bottom - chartArea.top;
    //             let width;
    //             let height;
    //             let gradient;
    //             if (!gradient || width !== chartWidth || height !== chartHeight) {
    //               // Create the gradient because this is either the first render
    //               // or the size of the chart has changed
    //               const width = chartWidth;
    //               const height = chartHeight;
    //               gradient = ctx.createLinearGradient(chartArea.left, 0, chartArea.right,0);
    //               gradient.addColorStop(0, '#9578FE');
    //               gradient.addColorStop(1, '#7E5AFF');
    //             }
    //
    //             return gradient;
    //           }
    //         }
    //       ]
    //     }
    //   }
    // );
  }
}
